module.exports = __webpack_public_path__ + "img/list_Story_26.f613003a.jpeg";